import { useLang } from 'hooks/lang';

import { Column, Row, Tag, Tooltip, ResponsiveRender } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import { UserAvatarGroup } from 'components/UserAvatar';
import { SquareMouseIcon } from 'components/Icons';

import { ProjectOptions, useProjectOption } from '../ProjectOptions';
import { TeamTag } from '../TeamTag';

import { useProjectProfile } from '../context';

export function ProjectHeader() {
  const { t } = useLang();
  const { project } = useProjectProfile();

  const changeTeam = useProjectOption('CHANGE_TEAM');

  return (
    <ResponsiveRender
      defaultContent={
        <Row>
          <GoBackButton />

          <UserAvatarGroup size={40} users={[project?.owner, project?.subOwner]} />

          <Column gap="1">
            <Row gap="2">
              <ProjectOptions />

              <h5 className="text-2xl font-semibold text-primary phone:text-xl">{project.name}</h5>
            </Row>

            <Row gap="2" className="opacity-70" flexWrap="wrap">
              <span>{project.clientName}</span>

              <TeamTag
                team={project.teamResponsible}
                action={changeTeam.isEnabled ? changeTeam.action : undefined}
              />

              <Tooltip ensurePresence content={t('project-type')}>
                <Tag
                  color="primary"
                  type="outlined"
                  round={false}
                  name={
                    <>
                      <SquareMouseIcon size={14} />
                      {t(project.type)}
                    </>
                  }
                />
              </Tooltip>
            </Row>
          </Column>
        </Row>
      }
      responsiveContent={
        <Column gap="1">
          <Row gap="2">
            <UserAvatarGroup users={[project?.owner, project?.subOwner]} />

            <h5 className="text-2xl font-semibold text-primary phone:text-xl">{project.name}</h5>
          </Row>

          <Row gap="2" className="opacity-70" flexWrap="wrap">
            <ProjectOptions />

            <span>{project.clientName}</span>

            <TeamTag
              team={project.teamResponsible}
              action={changeTeam.isEnabled ? changeTeam.action : undefined}
            />

            <Tooltip ensurePresence content={t('project-type')}>
              <Tag
                color="primary"
                type="outlined"
                round={false}
                name={
                  <>
                    <SquareMouseIcon size={14} />
                    {t(project.type)}
                  </>
                }
              />
            </Tooltip>
          </Row>
        </Column>
      }
    />
  );
}
